import React, { FunctionComponent } from "react";

const EmailActionReplyIcon: FunctionComponent = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="14"
      viewBox="0 0 15 14"
    >
      <path
        d="M1.01017 7.76088C0.82621 7.6032 0.734231 7.52436 0.700529 7.43054C0.67095 7.3482 0.67095 7.25813 0.700529 7.17578C0.734231 7.08197 0.82621 7.00313 1.01017 6.84545L7.39335 1.37415C7.71002 1.10272 7.86835 0.967003 8.00241 0.963678C8.11891 0.960788 8.23019 1.01197 8.30381 1.10231C8.38853 1.20625 8.38853 1.41479 8.38853 1.83186V5.06859C9.99713 5.35001 11.4694 6.16511 12.5635 7.38897C13.7563 8.72325 14.4161 10.45 14.417 12.2397V12.7009C13.6263 11.7483 12.639 10.9779 11.5228 10.4424C10.5387 9.97033 9.47485 9.69068 8.38853 9.61698V12.7745C8.38853 13.1915 8.38853 13.4001 8.30381 13.504C8.23019 13.5944 8.11891 13.6455 8.00241 13.6426C7.86835 13.6393 7.71002 13.5036 7.39335 13.2322L1.01017 7.76088Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default EmailActionReplyIcon;
